var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevHotspotButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "matrix(-1 0 0 1 41 0)",
    fill: "#E1251B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8333C10 10.6123 10.0878 10.4004 10.2441 10.2441C10.4004 10.0878 10.6123 10 10.8333 10C11.0543 10 11.2663 10.0878 11.4226 10.2441C11.5789 10.4004 11.6667 10.6123 11.6667 10.8333V29.1667C11.6667 29.3877 11.5789 29.5996 11.4226 29.7559C11.2663 29.9122 11.0543 30 10.8333 30C10.6123 30 10.4004 29.9122 10.2441 29.7559C10.0878 29.5996 10 29.3877 10 29.1667V10.8333ZM30 11.67C30.0002 11.3641 29.9162 11.064 29.7572 10.8026C29.5982 10.5412 29.3703 10.3287 29.0985 10.1882C28.8267 10.0478 28.5215 9.98485 28.2163 10.0063C27.9112 10.0278 27.6178 10.1329 27.3683 10.31L15.7017 18.5817C15.485 18.735 15.3082 18.9379 15.1858 19.1735C15.0634 19.409 14.9991 19.6703 14.9981 19.9358C14.9971 20.2012 15.0595 20.463 15.1802 20.6994C15.3008 20.9358 15.4762 21.14 15.6917 21.295L27.3583 29.69C27.6072 29.8695 27.9008 29.9768 28.2068 30.0001C28.5128 30.0234 28.8193 29.9618 29.0925 29.822C29.3657 29.6822 29.595 29.4697 29.7551 29.2079C29.9153 28.9461 30 28.6452 30 28.3383V11.67ZM16.6667 19.9417L28.3333 11.67V28.3367L16.6667 19.9417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevHotspotButton);
export default __webpack_public_path__ + "static/media/prevHotspotButton.7b416b1a63cb0211b57a9feaa2c8fa12.svg";
export { ForwardRef as ReactComponent };